import { Theme } from "@mui/material"
import { GridColDef } from "@mui/x-data-grid"
import { getStore } from "app/store/store"
import {
  DEFAULT_REPORTS_RESULT_COLUMN_SORT,
  IReportFilters,
  IReportForm,
  IReportResult,
  IReportsState,
  REPORTS_SORTABLE_ITEM_DRAGGED_CLASSNAME
} from "reports/model"
import { reportsActionCreator } from "reports/store/actions"

export const getReportForm = (isCreation: boolean, state?: IReportsState): IReportForm => {
  if (!state) {
    state = getStore().getState().reports
  }
  return isCreation ? state.createForm : state.editForm
}

export const setIsParametersPanelOpened = (isCreation: boolean, isOpened: boolean) => {
  if (getReportForm(isCreation).isParametersPanelOpened === isOpened) {
    return
  }
  getStore().dispatch(reportsActionCreator.setIsParametersPanelOpened(isCreation, isOpened))
}

export const sortReportColumns = (
  c1: GridColDef<IReportResult, any, any>,
  c2: GridColDef<IReportResult, any, any>
): number => {
  let c1Index = DEFAULT_REPORTS_RESULT_COLUMN_SORT.indexOf(c1.field)
  let c2Index = DEFAULT_REPORTS_RESULT_COLUMN_SORT.indexOf(c2.field)
  if (c1Index === -1) {
    c1Index = 300
  }
  if (c2Index === -1) {
    c2Index = 300
  }
  return c1Index - c2Index
}

export const getSortByItemSx = (theme: Theme): any => ({
  "cursor": "pointer",
  "padding": ".5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "display": "flex",
  "justifyContent": "space-between",
  "alignItems": "center",
  "width": "100%",
  "color": theme.palette.text.primary,
  "backgroundColor": theme.palette.background.paper,
  "border": theme.palette.border,
  "borderRadius": "1rem",
  "& *": {
    color: theme.palette.text.primary
  },
  [`&.${REPORTS_SORTABLE_ITEM_DRAGGED_CLASSNAME}`]: {
    "backgroundColor": theme.palette.primary.main,
    "color": theme.palette.specialText,
    "borderColor": theme.palette.specialText,
    "& *": {
      color: theme.palette.specialText
    }
  }
})

export const getReportsFilterChangeCount = (filters: IReportFilters): number => {
  let count = 0
  if (filters.campaignIds && filters.campaignIds.length > 0) {
    count++
  }
  if (filters.cityIds && filters.cityIds.length > 0) {
    count++
  }
  if (filters.countryIds && filters.countryIds.length > 0) {
    count++
  }
  if (filters.mediaIds && filters.mediaIds.length > 0) {
    count++
  }
  if (filters.mediaDimensions && filters.mediaDimensions.length > 0) {
    count++
  }
  if (filters.orderIds && filters.orderIds.length > 0) {
    count++
  }
  if (filters.postalCodes && filters.postalCodes.length > 0) {
    count++
  }
  if (filters.publisherIds && filters.publisherIds.length > 0) {
    count++
  }
  if (filters.screenIds && filters.screenIds.length > 0) {
    count++
  }
  if (filters.sspIds && filters.sspIds.length > 0) {
    count++
  }
  if (filters.stateIds && filters.stateIds.length > 0) {
    count++
  }
  if (filters.venueTypeIds && filters.venueTypeIds.length > 0) {
    count++
  }
  if (filters.weatherIds && filters.weatherIds.length > 0) {
    count++
  }
  if (typeof filters.mediaIsPortrait === "boolean") {
    count++
  }
  if (typeof filters.mediaIsVideo === "boolean") {
    count++
  }
  if (filters.startDate) {
    count++
  }
  if (filters.endDate) {
    count++
  }
  return count
}
